export default "__VITE_ASSET__c0f1c1ac__"